import * as React from 'react';
import classNames from 'classnames';
import AnimateHeight from 'react-animate-height';
import Icon from '../Icon';
import './Accordion.scss';

export interface IAccordionItemProps {
  title: string;
  children: {};
}

export interface IAccordionItemState {
  expanded: boolean;
}

class AccordionItem extends React.PureComponent<IAccordionItemProps, IAccordionItemState> {
  constructor(props: IAccordionItemProps) {
    super(props);

    this.state = {
      expanded: false
    }

    this.toggle = this.toggle.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  public toggle() {
    this.setState({ expanded: !this.state.expanded })
  }

  public handleKeyDown(event: React.KeyboardEvent) {
    switch (event.keyCode) {
      case 13: // Enter
      case 32: // Space
        this.toggle();
        break;
    }
  }

  public render() {
    const isExpanded = this.state.expanded === true;

    return (
      <div 
        className={classNames('accordion-item', isExpanded && 'is-expanded')}
      >
        <div 
          className="accordion-item-title px3 py2"
          onClick={this.toggle}
          onKeyDown={this.handleKeyDown}
          role="button"
          tabIndex={0}
        >
          <span className="f4">{this.props.title}</span>
          <div className="accordion-item-icon ml1">
            <Icon name="chevron-down" />
          </div>
        </div>
        <AnimateHeight 
          className="accordion-item-body"
          duration={500}
          height={isExpanded ? 'auto' : 0}
        >
          {this.props.children}
        </AnimateHeight>
      </div>
    );
  }
}

export default AccordionItem;



// WEBPACK FOOTER //
// ./src/components/Accordion/AccordionItem.tsx